export default __webpack_public_path__ + "static/media/hotspot_dlg.779c931b.svg";